<div class="card site-configuration">
  <div class="card-header site-configuration__header">
    <span class="card-title">Site Configuration</span>
    <button
      mat-flat-button
      (click)="emailTest()"
      color="accent"
      [disabled]="loading"
    >
      <mat-icon>email</mat-icon>
      Email Test
    </button>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

  <div class="card-body site-configuration__body">
    <div class="config-sections" *ngIf="configGroups.length; else emptyState">
      <section class="config-section" *ngFor="let group of configGroups">
        <h3 class="config-section__title">{{ group.title }}</h3>

        <div class="config-list">
          <div class="config-row" *ngFor="let element of group.items">
            <div class="config-row__label">
              <span>{{ element.name }}</span>
              <small *ngIf="element.description">{{ element.description }}</small>
            </div>

            <div
              class="config-row__control"
              [ngSwitch]="getValueType(element)"
            >
              <!-- String -->
              <ng-container *ngSwitchCase="valueType.String">
                <mat-form-field appearance="outline" class="config-field no-subscript">
                  <mat-label>{{ element.label || "Text" }}</mat-label>
                  <input
                    matInput
                    [(ngModel)]="element.value"
                    [ngModelOptions]="{ standalone: true }"
                    type="text"
                    [disabled]="!isSA()"
                  />
                </mat-form-field>
              </ng-container>

              <!-- Number -->
              <ng-container *ngSwitchCase="valueType.Number">
                <mat-form-field appearance="outline" class="config-field no-subscript">
                  <mat-label>{{ element.label || "Number" }}</mat-label>
                  <input
                    matInput
                    [(ngModel)]="element.value"
                    [ngModelOptions]="{ standalone: true }"
                    type="number"
                    (keypress)="
                      ($event.key === '-' || $event.key === '+') &&
                        $event.preventDefault()
                    "
                    [disabled]="!isSA()"
                  />
                </mat-form-field>
              </ng-container>

              <!-- Boolean -->
              <ng-container *ngSwitchCase="valueType.Boolean">
                <mat-slide-toggle
                  [(ngModel)]="element.value"
                  [ngModelOptions]="{ standalone: true }"
                  color="primary"
                  [disabled]="!isSA()"
                >
                  {{ element.value ? "Active" : "Inactive" }}
                </mat-slide-toggle>
              </ng-container>

              <!-- Email -->
              <ng-container *ngSwitchCase="valueType.Email">
                <mat-form-field
                  appearance="outline"
                  class="config-field"
                  [ngClass]="{ 'no-subscript': !emailInvalid(element.value) }"
                >
                  <mat-label>{{ element.label || "Email" }}</mat-label>
                  <input
                    matInput
                    type="email"
                    name="email_{{ element.id }}"
                    required
                    email
                    [(ngModel)]="element.value"
                    [disabled]="!isSA()"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="element.value = trimTextValue($event)"
                  />

                  <mat-error *ngIf="!element.value">Email is required</mat-error>
                  <mat-error *ngIf="element.value && emailInvalid(element.value)">
                    Enter a valid email address
                  </mat-error>
                </mat-form-field>
              </ng-container>

              <!-- Fallback -->
              <ng-container *ngSwitchDefault>
                <span>{{ element.value }}</span>
              </ng-container>
            </div>
          </div>
        </div>
      </section>
    </div>

    <ng-template #emptyState>
      <div class="empty-state" *ngIf="!loading">No site configuration found.</div>
    </ng-template>
  </div>

  <div class="card-footer site-configuration__footer" *ngIf="isSA()">
    <div mat-dialog-actions align="end">
      <button
        class="mx-1"
        mat-flat-button
        color="warn"
        type="button"
        (click)="onNoClick(false)"
        [disabled]="loading"
      >
        Cancel
      </button>
      <button
        class="mx-1"
        mat-flat-button
        color="primary"
        type="submit"
        (click)="onSubmit()"
        [disabled]="loading || hasInvalidConfiguration()"
      >
        Accept
      </button>
    </div>
  </div>
</div>
